module.exports = __webpack_public_path__ + "img/ata-messi.8fa6063a.png";